import AgentsAssistanceTypes from './agentsAssistance.types';
import AgentsAssistanceState from './agentsAssistance.state';
import AnyAction from 'store/anyActions';

const defaultState: AgentsAssistanceState = {
    ID: '',
    agentID: '',
    instanceID: '',
    raisedAt: 0,
    acknowledgement: {
        supervisorID: '',
        acknowledgedAt: 0,
    },
    resolvedAt: 0,
};

export default function (state: AgentsAssistanceState = defaultState, action: AnyAction): AgentsAssistanceState {
    switch (action.type) {
        case AgentsAssistanceTypes.SET_AGENTS_ASSISTANCE_STATE:
            return { ...state, ...action.payload };
        case AgentsAssistanceTypes.RESET_AGENTS_ASSISTANCE_STATE:
            return defaultState;
        default:
            return state;
    }
}
